import { useEffect } from "react";
import { AccountChip } from "@/components/account-chip";
import { FloatingActions } from "@/components/floating-actions";
import { UpdatePrompt } from "@/components/layout/update-prompt";
import { isNativeApp } from "@/lib/platform";
import { captureReferral } from "@/lib/referral";
import { TrackPageViews } from "./track-page-views";

/** Wraps every route: page-view tracking, remembering a friend's invite link, who you are signed in as, and the floating buttons. */
export function RootLayout() {
  useEffect(() => {
    captureReferral(window.location.search);
  }, []);
  return (
    <>
      <TrackPageViews />
      <AccountChip />
      <FloatingActions />
      {/* The apps update through the stores; a service worker would only serve stale files. */}
      {isNativeApp ? null : <UpdatePrompt />}
    </>
  );
}
